module.exports = __webpack_public_path__ + "static/media/icon-arrow.c3082c9c.svg";